import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-set-notification-email',
  templateUrl: './set-notification-email.component.html',
  styleUrls: ['./set-notification-email.component.scss'],
})
export class SetNotificationEmailComponent implements OnInit {
  notificationEmail: string;
  notificationEnabled: boolean;
  forwardEnabled: boolean;
  emailAddress: string;

  inputForm: FormGroup = new FormGroup({});
  testStatus = '';
  deliveredStatus = '';
  failedStatus = '';

  constructor(private cdr: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.inputForm.addControl(
      'emails',
      new FormControl(this.notificationEmail ?? '', [Validators.required]),
    );
    this.inputForm.addControl(
      'notification',
      new FormControl(this.notificationEnabled),
    );
    this.inputForm.addControl('forward', new FormControl(this.forwardEnabled));
  }

  setTestStatus(status: string): void {
    this.testStatus = status;
    this.deliveredStatus = '';
    this.failedStatus = '';
    this.cdr.detectChanges();
  }

  setDeliveryLines(deliveredTo: string[], notDeliveredTo: string[], pendingMessage = ''): void {
    this.deliveredStatus = deliveredTo.length ? `Delivered to ${deliveredTo.join(', ')}.` : '';
    this.failedStatus = notDeliveredTo.length ? `Not delivered to ${notDeliveredTo.join(', ')}.` : '';
    this.testStatus = pendingMessage;
    this.cdr.detectChanges();
  }
}
